import { useEffect, useMemo } from 'react';
import { useCartStore, useAuthStore } from '../context/store';
import { cartAPI } from '../utils/api';

const CartTracker = () => {
  const { items } = useCartStore();
  const { isAuthenticated } = useAuthStore();

  const payload = useMemo(() => {
    return items.map((item) => ({
      prodotto: item.product._id,
      nome: item.product.nome,
      quantita: item.quantity,
      prezzoUnitario: item.product.prezzoScontato || item.product.prezzoBase
    }));
  }, [items]);

  useEffect(() => {
    if (!isAuthenticated) return;

    const timer = setTimeout(() => {
      cartAPI.track({ items: payload }).catch(() => {});
    }, 800);

    return () => clearTimeout(timer);
  }, [isAuthenticated, payload]);

  return null;
};

export default CartTracker;
